"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var close_thin_1 = require("adp-react-icons/lib/adp/close-thin");
var check_circle_1 = require("adp-react-icons/lib/fa/check-circle");
var info_circle_1 = require("adp-react-icons/lib/fa/info-circle");
var exclamation_circle_1 = require("adp-react-icons/lib/fa/exclamation-circle");
var warning_1 = require("adp-react-icons/lib/fa/warning");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var button_1 = require("../button");
var chevron_right_1 = require("adp-react-icons/lib/fa/chevron-right");
var DEFAULT_TIMEOUT = 4000;
var AlertIcons = {
    'success': {
        icon: React.createElement(check_circle_1.default, null)
    },
    'info': {
        icon: React.createElement(info_circle_1.default, null)
    },
    'error': {
        icon: React.createElement(exclamation_circle_1.default, null)
    },
    'warning': {
        icon: React.createElement(warning_1.default, null)
    },
    'alert': {
        icon: React.createElement(warning_1.default, null)
    },
};
var AlertContent = /** @class */ (function (_super) {
    __extends(AlertContent, _super);
    function AlertContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.autoCloseTimeoutID = null;
        _this.setAutoCloseTimeout = function () {
            if (_this.autoCloseTimeoutID) {
                return;
            }
            _this.autoCloseTimeoutID = window.setTimeout(function () {
                this.autoCloseTimeoutID = null;
                if (this.props.onClose) {
                    this.props.onClose();
                }
            }.bind(_this), DEFAULT_TIMEOUT);
        };
        _this.cancelAutoCloseTimeout = function () {
            if (!_this.autoCloseTimeoutID) {
                return;
            }
            clearTimeout(_this.autoCloseTimeoutID);
            _this.autoCloseTimeoutID = null;
        };
        _this.handleClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        return _this;
    }
    AlertContent.prototype.componentDidMount = function () {
        if (this.props.autoClose) {
            this.setAutoCloseTimeout();
        }
    };
    AlertContent.prototype.componentWillUnmount = function () {
        this.cancelAutoCloseTimeout();
        if (this.props.onUnmount) {
            this.props.onUnmount();
        }
    };
    AlertContent.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, size = _b.size, type = _b.type, animate = _b.animate, closeable = _b.closeable, alertStyle = _b.alertStyle, title = _b.title, children = _b.children, variableContent = _b.variableContent, iconClassName = _b.iconClassName;
        var htmlProps = _1.omit(this.props, Object.keys(AlertContent.propTypes));
        var alertClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('alert')] = true,
            _a[vdl_prefix_1.vdlPrefix("alert--" + alertStyle + "-style")] = true,
            _a[vdl_prefix_1.vdlPrefix('alert--animate')] = animate,
            _a[vdl_prefix_1.vdlPrefix('alert--closeable')] = closeable,
            _a[vdl_prefix_1.vdlPrefix("alert--" + size)] = true,
            _a[vdl_prefix_1.vdlPrefix("alert--" + type)] = true,
            _a);
        var icon = typeof this.props.icon !== 'undefined' ?
            this.props.icon
            : AlertIcons[type] && AlertIcons[type].icon;
        var showFontIcon = typeof this.props.icon === 'undefined' && typeof this.props.iconClassName !== 'undefined';
        return (React.createElement("div", __assign({}, htmlProps, { key: "alert", className: classnames_1.classNames(alertClasses, className) }),
            React.createElement("div", { className: vdl_prefix_1.vdlPrefix('alert__container') },
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('alert__icon') }, showFontIcon ? React.createElement("i", { className: iconClassName }) : (icon && icon)),
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('alert__content-container') },
                    title &&
                        React.createElement("div", { className: vdl_prefix_1.vdlPrefix('alert__title') }, title),
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('alert__content') }, children),
                    variableContent &&
                        React.createElement("div", null,
                            React.createElement("div", { className: vdl_prefix_1.vdlPrefix('insites__link') },
                                React.createElement(button_1.Button, { buttonStyle: 'link' },
                                    "VIEW INSIGHTS ",
                                    React.createElement(chevron_right_1.default, null))))),
                closeable &&
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('alert__close'), onClick: this.handleClose },
                        React.createElement(close_thin_1.default, null)),
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('alert__bar') }))));
    };
    AlertContent.propTypes = {
        type: PropTypes.oneOf(['success', 'info', 'warning', 'error', 'alert']),
        size: PropTypes.oneOf(['sm', 'lg']),
        alertStyle: PropTypes.oneOf(['default', 'inline']),
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        closeable: PropTypes.bool,
        variableContent: PropTypes.bool,
        animate: PropTypes.bool,
        autoClose: PropTypes.bool,
        onClose: PropTypes.func,
        onUnmount: PropTypes.func,
        icon: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([false])]),
        children: PropTypes.node,
        className: PropTypes.string,
        iconClassName: PropTypes.string,
        eeAction: PropTypes.string,
        frequency: PropTypes.string,
        dateRange: PropTypes.string,
    };
    AlertContent.defaultProps = {
        type: 'info',
        closeable: false,
        variableContent: false,
        animate: true,
        size: 'sm',
        autoClose: false,
        alertStyle: 'default',
        eeAction: undefined,
        frequency: undefined,
        dateRange: undefined,
    };
    return AlertContent;
}(React.Component));
exports.AlertContent = AlertContent;
